// extracted by mini-css-extract-plugin
module.exports = {"description":"ContentItem_description__B_3UE","container":"ContentItem_container__G_uoO","link":"ContentItem_link__luWpb"};